import React, { useState } from 'react';

import { UsergroupAddOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';

import { useGlobalModal } from 'hooks';

const CreateNewMember = () => {
  const { openModal, MODAL_NAMES } = useGlobalModal();

  const onClick = () => {
    openModal(MODAL_NAMES.MEMBER_MAINTAIN.CREATE);
  };

  return (
    <>
      <RibbonButton
        size='small'
        icon={<UsergroupAddOutlined />}
        label='Create New Member'
        onClick={onClick}
      />
    </>
  );
};

export default CreateNewMember;
